import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsLayout, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { StaffPermissions, TrimesterAccMentorWithAccDetails } from '@interfaces';
import { DomainDataService } from '../../../../services';
import { getSetup } from './grid/get-setup';

export interface AllMentorsGridServiceInterface {
	layout: Signal<PageTabsLayout | undefined>,
	areaService: {
		reloadData: () => Promise<void>,
		selectedTrimesterName: Signal<string | undefined>,
		staffPermissions: Signal<StaffPermissions>
	}
}

@Component({
	selector: 'all-mentors-grid-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './all-mentors-grid.part.html',
})
export class AllMentorsGridPart {

	public parent = input.required<string>();
	public rows = input.required<TrimesterAccMentorWithAccDetails[]>();
	public service = input.required<AllMentorsGridServiceInterface>();

	private readonly util = inject(UtilityService);
	private readonly domain = inject(DomainDataService);
	private readonly dialogService = inject(DialogService);

	public setup = computed(() => getSetup(this.parent(), this.util, this.domain, this.dialogService, this.service()));

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		const layout = this.service().layout();
		if (layout) {
			return { layout: layout, viewSelector: true };
		}
		return undefined;
	});

}